<div fxFlex="100" fxLayout="column" fxLayoutAlign="space-evenly stretch">
  <mat-card>
    <h2 translate>generalOfInvestment.generalOfInvestment</h2>
    <p translate>generalOfInvestment.subtitle</p>
    <mat-card-content>
      <form [formGroup]="gralOfInvestmentForm" (ngSubmit)="searchInvestment()">
        <div fxFlex fxLayout="row wrap" class="form-wrapper">
          <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroChainUser || isBusinessDirector">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="macroChain"
              [cucumberId]="'macroChain'"
              [id]="'macroChainSelect'"
              [dataInput]="macroChainList"
              [placeholder]="'macrouser.title.groups'"
              [isRequired]="true"
              [showErrors]="gralOfInvestmentForm?.controls?.macroChain?.errors"
            >
            </scf-custom-select-search>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroOfficeUser || isBusinessDirector">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="macroOffice"
              [cucumberId]="'macroOffice'"
              [id]="'macroOfficeSelect'"
              [dataInput]="macroOfficeList"
              [placeholder]="'macrouser.title.offices'"
              [isRequired]="true"
              [showErrors]="gralOfInvestmentForm?.controls?.macroOffice?.errors"
            >
            </scf-custom-select-search>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="100" *ngIf="isMacroChainUser || isMacroOfficeUser"></div>
          <div fxFlex="50" fxFlex.gt-sm="30">
            <mat-form-field fxFlex="100" appearance="outline" monthYearFullDirective>
              <mat-label translate>generalOfInvestment.startDate</mat-label>
              <input
                [attr.data-cucumber-id]="'initialDate'"
                id="startDateGeneralOfInvestment"
                matInput
                [matDatepicker]="datepickerStart"
                formControlName="startDate"
                [max]="currentDate"
                autocomplete="off"
              />
              <mat-datepicker-toggle matSuffix [for]="datepickerStart"></mat-datepicker-toggle>
              <mat-datepicker
                [attr.data-cucumber-id]="'initialDatePicker'"
                id="startDateGeneralOfInvestmentDatePicker"
                #datepickerStart
                startView="multi-year"
                (monthSelected)="chosenMonthHandler($event, datepickerStart, 'startDate')"
                (yearSelected)="chosenYearHandler($event, 'startDate')"
              >
              </mat-datepicker>
              <mat-error *ngIf="gralOfInvestmentForm.controls.startDate.hasError('required')" translate>
                field.required
              </mat-error>
              <mat-error *ngIf="gralOfInvestmentForm.controls.startDate.errors?.dateFuture" translate>
                field.error.dateFuture
              </mat-error>
              <mat-error *ngIf="gralOfInvestmentForm.errors?.dateInvalid" translate>field.error.dateInitial</mat-error>
            </mat-form-field>
          </div>

          <div fxFlex="50" fxFlex.gt-sm="30">
            <mat-form-field fxFlex="100" appearance="outline" monthYearFullDirective>
              <mat-label translate>generalOfInvestment.endDate</mat-label>
              <input
                [attr.data-cucumber-id]="'finalDate'"
                id="endDateGeneralOfInvestment"
                matInput
                [matDatepicker]="datepickerEnd"
                formControlName="endDate"
                [max]="maxFinalDate"
                [min]="minDate"
                autocomplete="off"
              />
              <mat-datepicker-toggle matSuffix [for]="datepickerEnd"></mat-datepicker-toggle>
              <mat-datepicker
                [attr.data-cucumber-id]="'finalDatePicker'"
                id="endDateGeneralOfInvestmentDatePicker"
                #datepickerEnd
                startView="multi-year"
                (monthSelected)="chosenMonthHandler($event, datepickerEnd, 'endDate')"
                (yearSelected)="chosenYearHandler($event, 'endDate')"
              >
              </mat-datepicker>
              <mat-error *ngIf="gralOfInvestmentForm.controls.endDate.hasError('required')" translate>
                field.required
              </mat-error>
              <mat-error *ngIf="gralOfInvestmentForm.controls.endDate.errors?.dateFuture" translate>
                field.error.dateFuture
              </mat-error>
              <mat-error *ngIf="gralOfInvestmentForm.controls.endDate.hasError('matDatepickerMin')" translate
                >field.error.dateFinal</mat-error
              >
              <mat-error *ngIf="gralOfInvestmentForm.errors?.dateYearError" translate>field.notMoreThanAYear</mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="0" fxFlex.gt-sm="40"></div>

          <div fxFlex="40" fxFlex.gt-sm="30">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="division"
              [cucumberId]="'division'"
              [id]="'divisionGeneralOfInvestment'"
              [dataInput]="divisionList"
              [placeholder]="'generalOfInvestment.division'"
              [isRequired]="true"
              [showErrors]="gralOfInvestmentForm?.controls?.division?.errors"
            >
            </scf-custom-select-search>
          </div>

          <div fxFlex="60" fxFlex.gt-sm="40">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="office"
              [cucumberId]="'office'"
              [id]="'officeGeneralOfInvestment'"
              [dataInput]="officeList"
              [placeholder]="'generalOfInvestment.office'"
              [showErrors]="gralOfInvestmentForm?.controls?.office?.errors"
            >
            </scf-custom-select-search>
          </div>

          <div fxFlex="100" fxFlex.gt-sm="30">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="products"
              [cucumberId]="'product'"
              [id]="'productsGeneralOfInvestment'"
              [dataInput]="productList"
              [placeholder]="'generalOfInvestment.products'"
              [showErrors]="gralOfInvestmentForm?.controls?.products?.errors"
            >
            </scf-custom-select-search>
          </div>

          <div fxFlex="100" fxFlex.gt-sm="40">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="article"
              [cucumberId]="'article'"
              [id]="'articleGeneralOfInvestment'"
              [dataInput]="articleList"
              [placeholder]="'generalOfInvestment.articles'"
              [showErrors]="gralOfInvestmentForm?.controls?.article?.errors"
            >
            </scf-custom-select-search>
          </div>

          <div fxFlex="100" fxFlex.gt-sm="40">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="origin"
              [cucumberId]="'origin'"
              [id]="'originGeneralOfInvestment'"
              [dataInput]="originList"
              [placeholder]="'generalOfInvestment.origins'"
              [showErrors]="gralOfInvestmentForm?.controls?.origin?.errors"
            >
            </scf-custom-select-search>
          </div>

          <div fxFlex="100" fxFlex.gt-sm="100">
            <div class="general-investment_actions">
              <button
                id="searchButtonGeneralOfInvestment"
                color="accent"
                type="submit"
                mat-flat-button
                [disabled]="consultDisabled"
              >
                <mat-label translate>generalOfInvestment.consult</mat-label>
              </button>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <div fxFlex="100">
    <div fxFlex="100" fxLayout="column" fxLayoutAlign="space-around stretch" *ngIf="hasAnyOperation()">
      <h2 class="table-title" translate>generalOfInvestment.listOfInvestment</h2>

      <scf-general-of-investment-table fxFlex="100" *ngFor="let investment of totalsList" [tableRow]="investment">
      </scf-general-of-investment-table>

      <mat-card>
        <mat-card-content>
          <h2 translate [translateParams]="{ total: investmentData.total }">generalOfInvestment.totalInvestment</h2>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div *ngIf="noOperations">
    <mat-card>
      <mat-card-content>
        <div fxLayout="column" fxLayoutAlign="center center" class="invest-detail__card">
          <mat-label class="panel-request__label-no-operation" translate>investDetail.noOperations</mat-label>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="panel_footer__buttons" *ngIf="hasAnyOperation()">
    <div fxFlex="100" fxLayoutAlign="end start" fxLayoutGap="16px">
      <button id="createAllExcelOperationDetail" mat-stroked-button color="accent" (click)="createAllExcel()">
        <mat-icon class="icon-ic_file_download"></mat-icon>
        <span>{{ 'button.exportExcel' | translate | uppercase }}</span>
      </button>
      <button id="createAllPdfOperationDetail" mat-stroked-button color="accent" (click)="createAllPdf()">
        <mat-icon class="icon-ic_print"></mat-icon>
        <span>{{ 'button.print' | translate | uppercase }}</span>
      </button>
      <button id="rechargeOperationDetail" color="accent" mat-flat-button (click)="searchInvestment()">
        <span>{{ 'button.recharge' | translate | uppercase }}</span>
      </button>
    </div>
  </div>
</div>
